import React, { Component, useEffect } from 'react';
import LoadingScreen from './LoadingIndicator';
import { clearUser, setUser } from '../containers/User/actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { clearMembershipData } from '../containers/Membership/actions';
import {
  clearAppointmentData,
  fetchStatus,
} from '../containers/Appointment/actions';
import { createStructuredSelector } from 'reselect';
import makeSelectAppointment from '../containers/Appointment/selectors';

class ImpersonateUser extends Component {
  constructor() {
    super();
  }
  componentDidMount() {
    const params = this.props.location.search;
    const encodedData = new URLSearchParams(params).get('data');

    // const encodedData = params.split('?data=')[1];

    if (encodedData) {
      try {

        const decodedString = atob(
          encodedData
            .replace(/-/g, '+')
            .replace(/_/g, '/')
            .padEnd(
              encodedData.length +
                (encodedData.length % 4 === 0
                  ? 0
                  : 4 - (encodedData.length % 4)),
              '=',
            ),
        );
        const decodedData = JSON.parse(decodedString);

        if (decodedData) {
          this.props.clearAppointmentData();
          this.props.clearUser();
          this.props.clearMembershipData();
          localStorage.clear();

          const { user, token, adminUserDetails } = decodedData;
          const userData = { ...user, token };

          localStorage.setItem(
            'userBasicDetails',
            JSON.stringify({
              first_name: user.first_name,
              last_name: user.last_name,
              email: user.email,
              phone: user.phone
                ? user.phone
                    .replace(/\D+/g, '')
                    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                : '',
            }),
          );
          this.props.setUser(userData);
          localStorage.setItem('userToken', token.replace('Bearer', ''));
          localStorage.setItem('userTokenCreatedAt', new Date());
          localStorage.setItem('userId', user.id);
          localStorage.setItem('email', user.email);
          localStorage.setItem('impersonateUser', !!user.id);
          localStorage.setItem('adminUserId', adminUserDetails.adminId);
          localStorage.setItem('adminUserEmail', adminUserDetails.adminEmail);
          this.props.fetchStatus();
        }
      } catch (error) {
        console.log({ error }, 'KKKKKKKKKK');

        alert('Something went wrong, please try again');
        this.props.clearUser();
        this.props.clearMembershipData();
        this.props.clearAppointmentData();
        localStorage.clear();
        window.close();
        console.error('Error decoding data:', error);
      }
    }
  }

  render() {
    const { myStatus, fetchingStatus } = this.props.appointmentData;
    if ( !fetchingStatus && myStatus )
    {
      console.log({fetchingStatus, myStatus},'KKKKKKKK');
      
      return this.props.history.push('/appointment/locations');
    }
    return <LoadingScreen hangTight="true" />;
  }
}

const mapStateToProps = createStructuredSelector({
  appointmentData: makeSelectAppointment(),
});

const withConnect = connect(
  mapStateToProps,
  {
    clearUser,
    setUser,
    clearMembershipData,
    clearAppointmentData,
    fetchStatus,
  },
);

export default compose(
  withConnect,
  withRouter,
)(ImpersonateUser);
